import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import {
  clearLocalStorage,
  getLocalStorageItem,
  LOCAL_STORAGE_KEYS,
  setLocalStorageItem,
} from "../../utils/localStorage";
import { logout as logoutEvent, resetIdentity } from "../../utils/analytics";
import * as authActions from "../actions/authActions";

import { clearUser } from "./userSlice";

export const logoutUser = createAsyncThunk(
  "auth/logoutUser",
  async (_, { rejectWithValue, dispatch, getState }) => {
    try {
      const user = getState()?.user?.user;
      // Fire LOGOUT before detaching identity so it attaches to the right profile
      logoutEvent({ user });
      clearLocalStorage();
      await authActions.logoutUser();
      dispatch(clearUser());
      resetIdentity();
      return { clearAll: true };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  access: getLocalStorageItem(LOCAL_STORAGE_KEYS.ACCESS) || null,
  isAuthenticated: !!getLocalStorageItem(LOCAL_STORAGE_KEYS.ACCESS),
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: () => initialState,
    resetState: () => initialState,
    loginSuccess: (state, action) => {
      state.access = action.payload.access;
      state.isAuthenticated = true;
      state.error = null;
      setLocalStorageItem(LOCAL_STORAGE_KEYS.ACCESS, action.payload.access);
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(logoutUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(logoutUser.fulfilled, (state) => {
        return {
          ...initialState,
          access: null,
          isAuthenticated: false,
        };
      })
      .addCase(logoutUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { logout, resetState, loginSuccess, setLoading, setError } =
  authSlice.actions;
export default authSlice.reducer;
